import { useHttp } from '@/api';
import { httpApi } from '@/api/api';

/**
 * 共通設定情報の取得
 */
export function getCommonSetInfo() {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetCommonSetInfo)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 共通設定情報の変更
 */
export function changeCommonSetInfo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.ChangeCommonSetInfo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}



